<template>
    <div>
<BaseCleanPopup
    v-body
    :mask="true"
    @close="close"
    @c-outside="close"
    ref="popup"
    :h="37"
    :w="300"
    :winh="216"
    :winw="317"
    v-zindex
  >
    <template v-slot:header>
      <div>{{ $t("softwareNotUsed.title") }}</div>
    </template>
    <div class="content">
      <div class="msgs center padd-v-24">
            {{ $t("softwareNotUsed.msgBody") }}
      </div>
      <div class="bottom a-center bold">
          {{ $t("softwareNotUsed.continue") }}
          <div class="btns-container">
        <base-button @click="close">{{ $t("contactUs.clickHere") }}</base-button></div>
      </div>
    </div>
  </BaseCleanPopup>
    </div>
</template>

<script>
    export default {
     methods:{
         close(){
this.$emit('close')
         }
     }   
    }
</script>

<style lang="scss" scoped>
.content{
    display: flex;
    flex-direction: column;
    height: 100%;
    .msgs{
flex-grow: 1;
    }
    .bottom .btns-container{
height: 60px;
display: flex;
align-items: center;
justify-content: center;
    }
}
</style>